import {
  BaseButton,
  Props as BaseButtonProps,
} from '../LegacyButton/BaseButton';

export type Props = Omit<BaseButtonProps, 'isPill'> & {
  color?: 'primary' | 'secondary';
};

// These map to *-dark data-color attributes that are used for styling.
// In styling you'll look for [data-color='primary-dark'], for example.
// This mapping makes it simpler for consumers to pass in props.
const colorMappings: Record<string, BaseButtonProps['color']> = {
  primary: 'primary-dark',
  secondary: 'secondary-dark',
};

/**
 * <span style="color: #a81227; font-weight: bold;">⚠️ This component is deprecated, use [LegacyButton](../?path=/story/navigation-legacybutton--dark-color-variants) with dark color variants instead.</span>
 *
 * A Button for dark backgrounds.
 * @deprecated: Use the legacy `Button` with `primary-dark` or `secondary-dark` instead.
 */
export function DarkBackgroundButton({
  size = 'small',
  color = 'primary',
  ...props
}: Props) {
  return <BaseButton color={colorMappings[color]} size={size} {...props} />;
}
